import { FETCH_CLIENTS_FAILURE, FETCH_CLIENTS_REQUEST, FETCH_CLIENTS_SUCCESS } from "../Actions/Actions";


const initialState = {
  clients: [],
  isLoading: false,
  error: null,
};

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENTS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_CLIENTS_SUCCESS:
      return { ...state, isLoading: false, clients: action.payload };
    case FETCH_CLIENTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default clientReducer;
